import React, {useState} from 'react';
import PaymentReminderDialog from '../dialogs/PaymentReminderDialog';
import {MenuItem} from '@material-ui/core';
import {PaymentActionType} from './PaymentActionHelper';

const PaymentReminderAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  const [showPaymentReminderDialog, setShowPaymentReminderDialog] = useState(false);
  return (
    <>
      <MenuItem
        ref={ref}
        key={payment.id + 'reminder'}
        onClick={() => {
          setMenuAnchor(null);
          setShowPaymentReminderDialog(true);
        }}
      >
        {label}
      </MenuItem>
      <PaymentReminderDialog
        isOpen={showPaymentReminderDialog}
        onCancel={() => setShowPaymentReminderDialog(false)}
        onSuccess={() => setShowPaymentReminderDialog(false)}
        paymentId={payment.id}
        debtor={`${payment.debitor.firstName} ${payment.debitor.lastName}`}
      />
    </>
  );
});

export default PaymentReminderAction;
